export default "__VITE_ASSET__BAJD4b8g__"